<div class="modal-header" [ngClass]="{ 'alert-info': alertMessage }">
    @if (alertMessage) {
        <h4 class="modal-title pull-left">{{ alertMessage }}</h4>
    } @else {
        <h4 class="modal-title pull-left" translate>Choose a category</h4>
    }

    <button type="button" class="btn btn-icon btn-close btn-transparent" aria-label="Close" (click)="close()">
        <sb-inline-svg
            class="icon icon-close"
            aria-label="My icon"
            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'"></sb-inline-svg>
    </button>
</div>
<div class="modal-body" tabindex="-1">
    @if (nodes.length) {
        <form class="search-box mb-2">
            <input
                id="filter"
                type="text"
                class="form-control"
                name="searchQuery"
                [(ngModel)]="searchQuery"
                (keyup)="searchQueryUpdate.next($event)"
                placeholder="{{ 'search' | translate }}"
                appFocus
                [appAutoFocus]="true" />

            <button
                class="btn-transparent btn-clear"
                (click)="tree.treeModel.clearFilter(); cleanSearch(tree.treeModel)">
                <sb-inline-svg
                    class="icon icon-clear"
                    aria-label="My icon"
                    [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'"></sb-inline-svg>
            </button>
        </form>
        <tree-root
            class="category-tree"
            #tree
            [nodes]="nodes"
            (nodeActivate)="onChangeNode($event)"
            (initialized)="afterTreeInit($event)">
            <ng-template #treeNodeWrapperTemplate let-node let-index="index">
                <div
                    class="node-wrapper"
                    [style.padding-left]="node.getNodePadding()"
                    [ngClass]="{
                        'not-selectable-node': isIgnoreUnselected && !node.data.isClickable,
                        'is-unselected': searchQuery && !node.data.isSelected,
                    }"
                    [adaptivePosition]="false"
                    container="body"
                    tooltip="{{
                        isIgnoreUnselected && !node.data.isClickable
                            ? ('This category is not allowed to select' | translate)
                            : null
                    }}">
                    <tree-node-expander [node]="node"></tree-node-expander>
                    <div
                        class="node-content-wrapper"
                        [class.node-content-wrapper-active]="node.isActive"
                        [class.node-content-wrapper-not-unselectable]="node.isActive && node.data.ignoreDeactivate"
                        [class.node-content-wrapper-focused]="node.isFocused"
                        (click)="node.mouseAction('click', $event)"
                        (dblclick)="node.mouseAction('dblClick', $event)"
                        (contextmenu)="node.mouseAction('contextMenu', $event)"
                        (treeDrop)="node.onDrop($event)"
                        [treeAllowDrop]="node.allowDrop"
                        [treeDrag]="node"
                        [treeDragEnabled]="node.allowDrag()">
                        <tree-node-content [node]="node" [index]="index">
                            <span
                                tooltip="{{ node.data.name.length > 50 ? node.data.name : '' }}"
                                placement="auto"
                                container="body">
                                {{ node.data.name | truncate: 50 }}
                            </span>
                        </tree-node-content>
                    </div>
                </div>
            </ng-template>

            <!-- <ng-template #treeNodeTemplate let-node let-index="index">
                <span tooltip="{{node.data.name.length > 50? node.data.name : ''}}" placement="auto" container="body">
                    {{ node.data.name | truncate : 50}}
                </span>
            </ng-template> -->
        </tree-root>
    } @else {
        <div class="d-flex align-items-center">
            @if (isAdmin) {
                <p>
                    {{ "You don't have any categories yet. Add some categories" | translate }}
                    <a [href]="redirectToCategoriesUrl" translate>here</a>
                </p>
            } @else {
                <p translate>
                    You don't have any categories yet. Talk to your administrator to get access to add some.
                </p>
            }
        </div>
    }
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="close()" translate>Cancel</button>

    @if (!isDisableRemoving) {
        <button type="button" class="btn btn-primary" (click)="deleteCategory()" translate>Remove</button>
    }
</div>
